import { ResourceModel } from "src/app/core/models/resource.model";

export class Group extends ResourceModel<Group> {
    id!: string;
    group!: string
    resources!: Array<string>
    roles_list!: Array<string>
}